// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2GPMd","empty":"ModalGraph_empty__2K_QY"};